document.addEventListener('change', async (event) => {
  const input = event.target.closest('[data-rms-cart-registration]');
  if (!input) return;
  const status = input.parentElement.querySelector('[data-rms-registration-status]');
  const registration = input.value.toLocaleUpperCase('sv-SE').replace(/[^A-ZÅÄÖ0-9]/g, '').slice(0, 8);
  input.value = registration;
  status.textContent = 'Sparar…';
  try {
    const formData = new FormData();
    formData.append('attributes[Registreringsnummer för passformskontroll]', registration);
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('save');
    status.textContent = registration ? 'Sparat' : 'Frivilligt';
  } catch (error) {
    status.textContent = 'Kunde inte spara';
  }
});
